<script setup name="BaseRadioGroup"></script>

<template>
  <div class="space-y-3">
    <slot />
  </div>
</template>
